import { Grid } from "@mui/material";
import React from "react";
import UsersTable from "../../components/main/UsersTable/UsersTable";

const Users = () => {
  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      style={{ marginRight: 10, marginLeft: 10 }}
    >
      <UsersTable />
    </Grid>
  );
};

export default Users;
